import React from 'react'

const RateList = () => {
    return (
        <div className='p-8 md:p-10 lg:p-12 mb-28'>
            <div className='rounded-xl shadow-[0px_2px_4px_2px_rgba(0,0,0,0.05)] max-w-[520px] md:max-w-[640px] lg:max-w-[1080px] mx-auto'>
                <table className='border-collapse w-full mb-4'>
                    <thead>
                        <tr className='border-b-[#E4E4E7] border-b-[1px]'>
                            <th className='pl-6 md:pl-8 lg:pl-10 text-left w-[60%] text-lg md:text-xl lg:text-2xl py-4 md:py-6 lg:py-8'>Timeframe / Bag</th>
                            <th className='pr-6 md:pr-8 lg:pl-10 text-right w-[40%] text-lg md:text-xl lg:text-2xl'>Price</th>
                        </tr>
                    </thead>
                    {/* bg-[#FAFAFA] */}
                    <tbody>
                        <tr>
                            <td className='pl-6 md:pl-8 lg:pl-10 md:text-lg lg:text-xl py-2 md:py-4 lg:py-6'>1 Night</td>
                            <td className='pr-6 md:pl-8 lg:pl-10 md:text-lg lg:text-xl text-[#71717A] text-right'>Rp. 30.000</td>
                        </tr>
                        <tr className='bg-[#FAFAFA]'>
                            <td className='pl-6 md:pl-8 lg:pl-10 md:text-lg lg:text-xl py-2 md:py-4 lg:py-6'>1 Night</td>
                            <td className='pr-6 md:pl-8 lg:pl-10 md:text-lg lg:text-xl text-[#71717A] text-right'>Rp. 30.000</td>
                        </tr>
                    </tbody>
                </table>
                <div className='py-8 md:p-10 lg:p-12 px-20 text-center'>
                    <h4 className='text-lg md:text-xl lg:text-2xl font-bold mb-2 md:mb-4 lg:mb-6'>Please Note</h4>
                    <p className='text-sm md:text-base lg:text-lg text-[#71717A]'>Price may vary for a large volumed items (surfboard)<br /><br />We can arrange the price more in Whatsapp</p>
                </div>
            </div>
        </div>
    )
}

export default RateList